<template>
    <!-- EDI预配舱单 -->
    <div>
        EDI预配舱单
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style scoped lang="less">

</style>
